module.exports = __webpack_public_path__ + "img/Odoo.7eac1439.svg";